'use strict';

function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

module.exports = memoize;



//////////////////
// WEBPACK FOOTER
// ./~/@emotion/memoize/dist/memoize.cjs.js
// module id = 326
// module chunks = 168707334958949